import { SeamlessLogger } from './logger';
import { DatadogConfig, NamespacedLogger } from './types';
import { version as VERSION } from '../package.json' with { type: 'json' };
export const version = VERSION;

let logger: SeamlessLogger;

/**
 * Initializer for the Logging tool instance. It initializes the singleton on the first call and returns the Logger
 * instance with the correct namespace set.
 *
 * If no namespace is provided the default namespaced instance is provided.
 *
 * @ignore
 * @param {string} namespace namespace name
 * @return {*}  {SeamlessLogger} The logger instance correctly namespaced
 */
export const initializeLogger = (namespace?: string, datadogConfig?: DatadogConfig): NamespacedLogger => {
  if (!logger) {
    logger = new SeamlessLogger();
  }

  if (namespace) {
    logger.addNamespace(namespace, datadogConfig);
  }

  return logger.getNamespacedInstance(namespace);
};

export { SeamlessLogger };
